import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const attendanceSlice = createSlice({
    name: 'attendance',
    initialState: {
        selectedCourse: {
            id: null,
            name: null
        },
        selectedAttendance: {
            branch_name: null,
        },
        capturedImages: [] as string[],
        checkInImage: "",
        currentDate: new Date().toISOString(), // Current viewing date in schedule as ISO string
    },
    reducers: {
        setSelectedCourse(state, action) {
            state.selectedCourse = action.payload
        },
        setSelectedAttendance(state, action) {
            state.selectedAttendance = action.payload
        },
        setCapturedImages(state, action: PayloadAction<string[]>) {
            state.capturedImages = action.payload;
        },
        addCapturedImage(state, action: PayloadAction<string>) {
            if (state.capturedImages.length < 10) {
                state.capturedImages.push(action.payload);
            }
        },
        setCheckInImage(state, action: PayloadAction<string>) {
            state.checkInImage = action.payload;
        },
        setCurrentDate(state, action: PayloadAction<string | Date>) {
            // Accept both string and Date, but always store as ISO string
            state.currentDate = typeof action.payload === 'string' ? action.payload : action.payload.toISOString();
        },
        removeCapturedImage(state, action: PayloadAction<number>) {
            state.capturedImages.splice(action.payload, 1);
        },
        clearCapturedImages(state) {
            state.capturedImages = [];
        },
    },
})

export const { setSelectedCourse, setSelectedAttendance, removeCapturedImage, clearCapturedImages, addCapturedImage, setCapturedImages, setCheckInImage, setCurrentDate } = attendanceSlice.actions
export default attendanceSlice.reducer